import { GetCompanyInfoByCompanyIdMeta, GetCompanyInfoByCompanyIdPayload } from 'types/store/GetCompanyInfoByCompanyId';
import { createAsyncReducer } from 'utils/Redux';

import { getCompanyInfoByCompanyIdActions } from '../actions';

export default createAsyncReducer<GetCompanyInfoByCompanyIdMeta, GetCompanyInfoByCompanyIdPayload>(getCompanyInfoByCompanyIdActions);
